// Bundesland → ELSTER-Konfiguration (offizielle Umrechnungstabelle, vgl.
// de.wikipedia.org/wiki/Steuernummer).
export const BL_CONFIG: Record<string, { lkz: string; insertZero: boolean }> = {
  'Baden-Württemberg': { lkz: '28', insertZero: false },
  'Bayern': { lkz: '9', insertZero: true },
  'Berlin': { lkz: '11', insertZero: false },
  'Brandenburg': { lkz: '3', insertZero: true },
  'Bremen': { lkz: '24', insertZero: false },
  'Hamburg': { lkz: '22', insertZero: false },
  'Hessen': { lkz: '26', insertZero: false },
  'Mecklenburg-Vorpommern': { lkz: '4', insertZero: true },
  'Niedersachsen': { lkz: '23', insertZero: false },
  'Nordrhein-Westfalen': { lkz: '5', insertZero: true },
  'Rheinland-Pfalz': { lkz: '27', insertZero: false },
  'Saarland': { lkz: '10', insertZero: false },
  'Sachsen': { lkz: '3', insertZero: true },
  'Sachsen-Anhalt': { lkz: '3', insertZero: true },
  'Schleswig-Holstein': { lkz: '21', insertZero: false },
  'Thüringen': { lkz: '4', insertZero: true },
};

export const BUNDESLAENDER = Object.keys(BL_CONFIG);

// PLZ → Bundesland-Name (Standard für ELSTER, vom Nutzer überschreibbar).
export const getElsterBundesland = (plz: string): string | null => {
  const digits = plz.replace(/\D/g, '');
  if (digits.length < 5) return null;
  const n = parseInt(digits.substring(0, 5), 10);
  if (n >= 1000  && n <= 1936)  return 'Sachsen';
  if (n >= 1937  && n <= 2999)  return 'Brandenburg';
  if (n >= 3000  && n <= 3999)  return 'Brandenburg';
  if (n >= 4000  && n <= 4639)  return 'Sachsen';
  if (n >= 4640  && n <= 6999)  return 'Sachsen-Anhalt';
  if (n >= 7000  && n <= 7999)  return 'Thüringen';
  if (n >= 8000  && n <= 9999)  return 'Sachsen';
  if (n >= 10000 && n <= 14199) return 'Berlin';
  if (n >= 14200 && n <= 16999) return 'Brandenburg';
  if (n >= 17000 && n <= 19999) return 'Mecklenburg-Vorpommern';
  if (n >= 20000 && n <= 21999) return 'Hamburg';
  if (n >= 22000 && n <= 25999) return 'Schleswig-Holstein';
  if (n >= 26000 && n <= 27569) return 'Niedersachsen';
  if (n >= 27570 && n <= 27580) return 'Bremen';
  if (n >= 27581 && n <= 27999) return 'Niedersachsen';
  if (n >= 28000 && n <= 28779) return 'Bremen';
  if (n >= 28780 && n <= 31999) return 'Niedersachsen';
  if (n >= 32000 && n <= 33999) return 'Nordrhein-Westfalen';
  if (n >= 34000 && n <= 36999) return 'Hessen';
  if (n >= 37000 && n <= 38999) return 'Niedersachsen';
  if (n >= 39000 && n <= 39999) return 'Sachsen-Anhalt';
  if (n >= 40000 && n <= 59999) return 'Nordrhein-Westfalen';
  if (n >= 60000 && n <= 65999) return 'Hessen';
  if (n >= 66000 && n <= 66999) return 'Saarland';
  if (n >= 67000 && n <= 67999) return 'Rheinland-Pfalz';
  if (n >= 68000 && n <= 69999) return 'Baden-Württemberg';
  if (n >= 70000 && n <= 79999) return 'Baden-Württemberg';
  if (n >= 80000 && n <= 87999) return 'Bayern';
  if (n >= 88000 && n <= 89999) return 'Baden-Württemberg';
  if (n >= 90000 && n <= 97999) return 'Bayern';
  if (n >= 98000 && n <= 99999) return 'Thüringen';
  return null;
};

// Berechnet die 13-stellige (bundeseinheitliche) ELSTER-Steuernummer aus der
// Landes-Steuernummer + PLZ/Bundesland. Leerer String = nicht berechenbar.
export const computeElster = (steuernr: string, plz: string, bundesland?: string): string => {
  const digits = steuernr.replace(/\D/g, '');
  // Manuell gewähltes Bundesland hat Vorrang vor der PLZ-Ableitung.
  const blName = (bundesland && BL_CONFIG[bundesland]) ? bundesland : getElsterBundesland(plz);
  const cfg = blName ? BL_CONFIG[blName] : null;
  if (!cfg) return '';
  if (cfg.insertZero) {
    // 1-stelliger LKZ: Finanzamt(3) + '0' + Rest(8).
    if (digits.length === 11) return cfg.lkz + digits.slice(0, 3) + '0' + digits.slice(3);
    if (digits.length === 12 && digits[3] === '0') return cfg.lkz + digits;
    return '';
  }
  // 2-stelliger LKZ: Finanzamt(2) + '0' + Rest(8).
  if (digits.length === 10) return cfg.lkz + digits.slice(0, 2) + '0' + digits.slice(2);
  if (digits.length === 11) {
    if (digits[0] === '0') return cfg.lkz + digits.slice(1, 3) + '0' + digits.slice(3);
    if (digits[2] === '0') return cfg.lkz + digits;
  }
  return '';
};
